import { createContext, useContext } from 'react';
const NotImplementedComponent = () => {
  throw new Error('DefaultCardFormatter must be set to render cards');
};
export const CardContainerContext = /*#__PURE__*/createContext({
  DefaultCardFormatter: NotImplementedComponent,
  reorderable: false,
  observerManager: undefined,
  ActionFormatter: undefined,
  isInIframe: false
});
export const CardContainerContextProvider = CardContainerContext.Provider;
export function useCardContainerContext() {
  return useContext(CardContainerContext);
}